module.exports = __webpack_public_path__ + "img/dolacz-do-klubu-baner.1265a5f3.png";